import { Injectable } from '@angular/core';
import {
  Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router,
  NavigationEnd
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EventListStore } from './event-list.store';
import { Page } from '../../shared/models/page';
import { OnyxSummaryEvent } from '../models/event.summary';
import { EventSearchParametersStore } from './event-search-parameters.store';
import { OrderedSet } from 'immutable';
import { SearchEventUtils } from '../utils/search-event-utils';
import { LogService } from '../../shared/log/log.service';
import { EventSearchFilter } from '../models/event-filter';

@Injectable()
export class EventsResolver implements Resolve<any> {

  constructor(private eventsListStore: EventListStore,
              private searchParametersStore: EventSearchParametersStore,
              private logService: LogService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Page<OnyxSummaryEvent>> {
    const searchTextList: OrderedSet<string> = SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
    const searchFilterList: OrderedSet<EventSearchFilter> = SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);
    if (!searchTextList && ! searchFilterList) {
      this.searchParametersStore.reset();
    } else {
      if (searchTextList) {
        this.searchParametersStore.setSearchTextSet(searchTextList);
      }
      if (searchFilterList) {
        this.searchParametersStore.setFilterSet(searchFilterList);
      }
    }

    this.logService.debug('route.url: ' + route.url);
    this.logService.debug('state.url: ' + state.url);

    if (route.data && route.data[ 'view' ]) {
      this.logService.debug('route.data[ \'view\' ]: ' + route.data[ 'view' ]);
      const showDefaultView = route.data['view'] as string;
      this.logService.debug('showDefaultView: ' + showDefaultView);

      this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');

    }

    return this.eventsListStore.loadEvents();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/events.resolver.ts